<div class="emulation-header">
  <div class="emulation-header__badge">お客様対応用</div>

  <div class="emulation-header__body">
    <p class="emulation-header__title">第一生命インターネットサービス</p>
    <p class="emulation-header__description">画面を閉じる際には「ログアウト」ボタンを押してください。</p>
  </div>

  <div class="emulation-header__actions">
    <button class="emulation-header__btn emulation-header__btn--primary" type="button" (click)="onCustomerUsageClick()">
      お客様利用内容
    </button>
    <button class="emulation-header__btn emulation-header__btn--secondary" type="button" (click)="onLogoutClick()">
      ログアウト
    </button>
  </div>
</div>
